import { useQuery } from '@apollo/client';
import { GET_OSW_VALUE_TAGS } from '../../graphql/queries/oneSongWonder/onesongwonder';

const useGetOswValueTags = () => {
  const { loading, data, error } = useQuery(GET_OSW_VALUE_TAGS, {
    fetchPolicy: 'network-only',
  });

  return {
    loading,
    tags: data?.tags ?? [],
    error,
  };
};

export default useGetOswValueTags;
